import { render, staticRenderFns } from "./CartSideBar.vue?vue&type=template&id=34e0556d&"
import script from "./CartSideBar.vue?vue&type=script&lang=js&"
export * from "./CartSideBar.vue?vue&type=script&lang=js&"
import style0 from "./CartSideBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports